import { Card, Col, Row } from "react-bootstrap"

export default function ApplicationsDashboardCards() {

    return (

        <Row className="mb-4">

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Licenças Ativas</h6>
                        <h3>128</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Licenças Expiradas</h6>
                        <h3>21</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Trials</h6>
                        <h3>9</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Usuários</h6>
                        <h3>87</h3>
                    </Card.Body>
                </Card>
            </Col>

        </Row>

    )

}